import { z } from 'zod';
import type { UserProfile } from '@shared/models/user';
import type { ApiErrorCode } from '@shared/services/api-errors';

export type LoginResponse = {
  success: boolean;
  error: string;
  userName: string;
  logonUsername: string;
  accessAccountId: string;
  userNameDisplay: string;
  displayName: string;
  externalUserReference: string;
  leapSessionId: string;
  aspnetSessionId: string;
  allowImitation: boolean;
  isImitating: boolean;
  imitatingUserId: string;
  imitatingUserName: string;
  logOnShowTerms: boolean;
};

type LoginMessageKey = 'usernameRequired' | 'passwordRequired';

export function createLoginSchema(t: (key: LoginMessageKey) => string) {
  return z.object({
    username: z.string().min(1, t('usernameRequired')),
    password: z.string().min(1, t('passwordRequired')),
  });
}

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;

export type LoginActionResult =
  { success: true; user: UserProfile } | { success: false; error: string; code: ApiErrorCode };
